// extracted by mini-css-extract-plugin
export default {"avatar":"CoachAvatar_avatar__ZazsH","img":"CoachAvatar_img__wNd7r","full":"CoachAvatar_full__9zXHc","portrait":"CoachAvatar_portrait__-tXaF"};